export default "__VITE_ASSET__oFHdCnxt__"